import { Directive } from "vue";

type ClickOutsideFuncType = () => void;

interface HTMLElementExtended extends HTMLElement {
    isClickedOutside: (event: MouseEvent) => void;
}

export const vClickOutside: Directive<HTMLElementExtended, ClickOutsideFuncType> = {
    beforeMount(el, binding) {
        el.isClickedOutside = (event: MouseEvent) => {
            if (!(el === event.target || el.contains(event.target as Node))) {
                binding.value();
            }
        };
        document.addEventListener("click", el.isClickedOutside);
    },
    beforeUnmount(el) {
        document.removeEventListener("click", el.isClickedOutside);
    },
};
